// src/components/Button.jsx
import React from 'react';

const Button = ({ 
  children, 
  onClick, 
  className = '', 
  type = 'button', 
  variant = 'primary', 
  size = 'medium', 
  disabled = false 
}) => {
  // Base styles applied to all buttons
  const baseStyles = 'font-accent rounded-lg flex items-center justify-center transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1 border';

  // Brand-aware variant styles
  const variantStyles = {
    primary: 'bg-primary text-white hover:bg-primary-light focus:ring-primary shadow-sm',
    secondary: 'bg-secondary text-white hover:bg-secondary-light focus:ring-secondary shadow-sm',
    accent: 'bg-accent text-dark hover:bg-accent-light focus:ring-accent shadow-sm',
    outline: 'border-primary text-primary bg-transparent hover:bg-primary hover:text-white focus:ring-primary shadow-sm',
    simple: 'border-secondary text-secondary bg-transparent hover:bg-secondary-light hover:text-white focus:ring-secondary shadow-sm',
    ghost: 'border-transparent text-dark hover:bg-neutral focus:ring-neutral shadow-none'
  };

  // Size styles
  const sizeStyles = {
    tiny: 'py-1 px-2 text-xs min-h-[24px]',
    small: 'py-2 px-3 text-sm min-h-[32px]',
    medium: 'py-2.5 px-4 text-[13px] min-h-[40px]',
    large: 'py-3 px-5 text-base min-h-[44px]'
  };

  const disabledStyles = disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer';

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        ${baseStyles}
        ${variantStyles[variant]}
        ${sizeStyles[size]}
        ${disabledStyles}
        ${className}
      `}
    >
      {children}
    </button>
  );
};

export default Button;
